var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.843.825H1.597L0 5.47h1.03v8.28l2.12-.91V2.791L3.843.825zM17.008 3.392H25.9l.614-1.643h-9.11l.223-.924h-2.244L14.5 4.637h2.206l.302-1.245zM14.304 13.374h2.254l3.04-5.172h-2.245l-3.05 5.172z",
    fill: "#386EE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.944 4.883l.614-1.643H7.543l.32-2.583H5.745L5.423 3.24H3.467v1.643h1.75l-1.057 8.49H6.29l1.052-8.49h4.603zM26.104 7.614l.614-1.643H14.173v1.643h7.098v3.82s-.06 1.761 1.644 1.939h2.875l.831-1.623h-2.498s-.89.04-.89-.811V7.614h2.871z",
    fill: "#386EE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.557 10.94V5.47H8.596v5.964s-.06 1.762 1.644 1.939h1.802l.832-1.622h-1.426s-.891.04-.891-.811zM11.363 2.283a.93.93 0 10-1.717-.711.93.93 0 001.717.711z",
    fill: "#386EE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.643 0L18.74 4.667l1.106.29-1.623 2.666 5.295-3.814h-2.311L24.164 0h-3.52z",
    fill: "#FEB34E"
  })));
}
export default __webpack_public_path__ + "static/preferred.b7a98a42.svg";
export { SvgPreferred as ReactComponent };